export const DEFAULT_MQTT_PORT = 1883;
export const DEFAULT_MQTTS_PORT = 8883;
export const MQTT_EVENT_TYPES = [
    {
        value: 'MQTT_HUB_META_DATA_FEED',
        label: 'MqttPublisher.HubMetaDataFeed',
        info: 'MqttPublisher.HubMetaDataFeedInfo',
    },
    {
        value: 'MQTT_SAMPLE_FEED',
        label: 'MqttPublisher.SampleFeed',
        info: 'MqttPublisher.SampleFeedInfo',
    },
] as const;

export type MqttPublisherAuthType = 'BASIC_AUTHENTICATION' | 'CERTIFICATE_BASED';

export type MqttPublisherProtocol = 'MQTT' | 'MQTTS';

export interface MqttPublisherSensorUnits {
    radonUnit: string;
    tempUnit: string;
    pressureUnit: string;
    vocUnit: string;
}

export interface MqttPublisherConfig {
    clientId: string;
    name: string;
    protocol: MqttPublisherProtocol;
    host: string;
    port: number;
    username: string | null;
    active: boolean;
    authType: MqttPublisherAuthType;
    subscribedToAll: boolean;
    eventTypes: string[];
    locations: string[];
    sensorUnits: MqttPublisherSensorUnits;
}

export interface MqttPublisherFormValues {
    name: string;
    protocol: MqttPublisherProtocol;
    host: string;
    port: number;
    authType: MqttPublisherAuthType;
    username?: string;
    password?: string;
    clientCertificate?: File;
    clientKey?: File;
    caCertificate?: File;
    active: boolean;
    subscribedToAll: boolean;
    eventTypes: string[];
    locations: string[];
    sensorUnits: MqttPublisherSensorUnits;
}
